import { render } from "./Pagination.vue?vue&type=template&id=6746e7c6&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css?vue&type=style&index=0&id=6746e7c6&scoped=true&lang=css&external"
import "./Pagination.vue?vue&type=style&index=1&id=6746e7c6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6746e7c6"]])

export default __exports__